
































import BaseComponent from '@/components/base-component.vue';
import { listActiveClinicStates } from '@/services/clinic-states';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class UiAutocompleteClinicStates extends BaseComponent {
  @Prop()
  public value: any;

  @Prop({ default: 'Estado Clínico' })
  public label?: string;

  @Prop({ default: false })
  public required?: boolean;

  @Prop({ default: false })
  public disabled?: boolean;

  @Prop({ default: false })
  public returnObject?: boolean;

  @Prop({ default: false })
  public clearable?: boolean;

  @Prop({ default: () => [] })
  private rules?: any[];

  loading = false;
  error = false;
  item = null;
  items = [];

  mounted() {
    this.load();
  }

  public onChange(val) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  private load(): void {
    this.item = null;
    this.loading = true;
    listActiveClinicStates().subscribe((res) => {
      this.items = res;
      this.loading = false;
      setTimeout(() => {
        if (this.value) {
          let idx = -1;
          if (this.returnObject) {
            idx = this.items.findIndex((i) => i.id == this.value.id);
          } else {
            idx = this.items.findIndex((i) => i.id == this.value);
          }
          if (idx > -1) {
            this.item = this.items[idx];
          }
        }
        if (this.returnObject) {
          this.onChange(this.item);
        } else {
          if (this.item) {
            this.onChange(this.item.id);
          }
        }
      }, 10);
    });
  }

  public onLinkClick(link) {
    window.open(link, 'doclink');
  }
}
